import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { ErrorCard, TableWithPagination } from '@starsoft/common/components';
import { bonusCoinsColumns } from '@/constants/bonusCoinsColumns';
import { platformAssets } from '@/utils/assets';
import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import useTransactionsNavigation from '@/hooks/useTransacionsNavigation';
import { useCallback } from 'react';
import { BonusCoinMapping } from '@/models/bonusCoinMapping';
import { ModalsKey } from '@/enums/modalsKey';
import { useBonusCoinMappings } from '@/api/bonus-coin-mappings';
import { UserBonusModalCoinTableProps } from './props';

export default function UserBonusModalCoinTable({
  isLoading,
  userBonus,
}: UserBonusModalCoinTableProps) {
  const { t } = useTranslation('common');
  const { navigateToModal } = useModalNavigation();
  const { getModalSearchParams } = useTransactionsNavigation();
  const {
    page,
    data,
    fetchNextPage,
    setCurrentPage,
    fetchPreviousPage,
    error: errorBonusCoinMapping,
    refetch: refetchBonusCoinMapping,
    isPending: loadingBonusCoinMapping,
  } = useBonusCoinMappings({ bonusId: userBonus?.bonus?.id });

  const onRedirect = useCallback(
    (mapping: BonusCoinMapping) => {
      const url = getModalSearchParams(mapping?.coin?.type, mapping?.coin?.id);
      navigateToModal(ModalsKey.Deposit, url);
    },
    [getModalSearchParams, navigateToModal],
  );

  if (errorBonusCoinMapping) {
    return (
      <ErrorCard
        error={errorBonusCoinMapping}
        refetch={refetchBonusCoinMapping}
      />
    );
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{t('bonus_coins_table_title')}</h3>
      <p className={styles.container__description}>
        {t('bonus_coins_table_description', {
          app_provider: platformAssets.app,
        })}
      </p>
      <TableWithPagination
        data={data}
        page={page}
        handleRedirect={onRedirect}
        columns={bonusCoinsColumns}
        fetchNextPage={fetchNextPage}
        setCurrentPage={setCurrentPage}
        refetch={refetchBonusCoinMapping}
        fetchPreviousPage={fetchPreviousPage}
        isLoading={isLoading || loadingBonusCoinMapping}
      />
    </div>
  );
}
